import(/* webpackMode: "eager" */ "/vercel/path0/packages/service/src/app/global-error.tsx");
